import { defineMessages } from 'react-intl';
import { fieldNames } from './model';

export const label = defineMessages({
  [fieldNames.adminEmail]: {
    id: 'graphql.create-ems-indorse.company-admin.email',
    defaultMessage: `Email`,
  },
});

export const buttons = defineMessages({
  submitButton: {
    id: 'graphql.create-ems-indorse.submit.company',
    defaultMessage: 'Start Free Trial',
  },
  slackButton: {
    id: 'graphql.create-ems-indorse.slack.company',
    defaultMessage: 'Try with Slack',
  },
});
export const content = defineMessages({
  pageTitle: {
    id: 'pages.assignment-magic-thanks.page-title',
    defaultMessage: 'Verify',
  },
  pageSubTitle: {
    id: 'pages.assignment-magic-thanks.page-sub-title',
    defaultMessage:
      'To verify your email, please check your inbox. Do not forget to check your spam folder and whitelist our email - info@indorse.io',
  },
  pageCompanies: {
    id: 'pages.assignment-magic-thanks.page-companies',
    defaultMessage: "You're in good company.",
  },
});

export const hero = {
  subTitle: {
    id: 'pages.ems-indorse.hero.graphql.subtitle',
    defaultMessage:
      'Improve productivity by identifying blind spots in your software engineering team',
  },
};
